import { textFieldStyles } from '../Declarations.styles';

export const checkboxInsteadOfRadioStyles = {
  margin: '4px 0 !important',

  '& .checkbox': {
    gap: '8px',
  },
};

export const defaultCheckboxStylesProps = {
  withMarginLeft: true,
};

export const checkboxWrapperStyles = {
  marginTop: 0,
};

export const updatedTextFieldStyles = {
  ...textFieldStyles,
  marginBottom: '5px !important',
  paddingLeft: '10px !important',
};
